import { string } from 'yup'

export const PickupAddressSchema = () => ({
  zipCode: string().nullable(),
  address: string().nullable(),
  addressDetail: string().nullable(),
  district: string().nullable(),
  country: string().nullable(),
  state: string().nullable(),
  city: string().nullable(),
  latLong: string()
    .nullable()
    .test({
      name: 'latLongFormat',
      test: function (value) {
        if (!value) {
          return true
        }
        return /^-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?$/.test(value)
      },
      message: "Deve ser preenchido no seguinte formato 'Latitude, Longitude'"
    })
})
